import { BaseEnv } from '@aipb/env/model';
import { BaseEnvService } from '@aipb/env/util';
import { Inject, Injectable } from '@angular/core';
import { ConfigViewerConfig } from './config-viewer.config';
import { ConfigViewerEnv } from './config-viewer.env';
import { APP_CONFIG } from '@aipb/util/di';

@Injectable({
  providedIn: 'root'
})
export class ConfigViewerEnvService extends BaseEnvService<ConfigViewerEnv, ConfigViewerConfig> {
  constructor(@Inject(APP_CONFIG) protected override config: BaseEnv) {
    super(config, 'config-viewer', (config) => new ConfigViewerConfig(config));
  }
}
